import {Component, OnInit} from '@angular/core';
import {M2appFormComponent} from "../m2app-form/m2app-form.component";
import {NavStatusService} from "../../nav-status.service";
import {NavigationPoint} from "../../navigation-point";

@Component({
  selector: 'app-feedback',
    imports: [
        M2appFormComponent
    ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent implements OnInit {
  constructor(private navStatusService: NavStatusService) {
  }
  ngOnInit() {
    this.navStatusService.setActiveNavPoint(NavigationPoint.home);
  }

}
